import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps';

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOLGE_API_KEY,
    libraries: 'places',
  },
});

Vue.component('gmap-map', VueGoogleMaps.Map);
Vue.component('gmap-marker', VueGoogleMaps.Marker);
